<template>
  <div>
    <BoxListAlert v-if="errorMessages.length > 0">
      <p v-for="(message, index) in errorMessages" :key="index">
        ・{{ message }}
      </p>
    </BoxListAlert>
  </div>
</template>
<script setup>
import BoxListAlert from '../../molecules/box_list/BoxListAlert.vue'

defineProps({
  errorMessages: {
    type: Array,
    required: false,
    default: () => []
  }
})
</script>
